import gql from 'graphql-tag';
import { CONTROL_PHOTO_FRAGMENT } from './controlPhoto';

export const SETUP_INSTRUCTION_FRAGMENT = gql`
    fragment SetupInstructionFragment on SetupInstruction {
        ... on CheckTemperatureInstruction {
            createdAt
            isFinishForced
            isNeeded
            noTemperatureComment
            state
            stateHistory {
                createdAt
                state
            }
            temperature
            type
            updatedAt
        }
        ... on CheckBoxTemperatureInstruction {
            createdAt
            isFinishForced
            isNeeded
            noTemperatureComment
            state
            stateHistory {
                createdAt
                state
            }
            temperature
            thermometerNumber
            type
            updatedAt
        }
        ... on HotDrinksInstruction {
            createdAt
            hasCleanedCollectingTray
            hasCleanedMachine
            hasReplenishedConsumables
            hasReplenishedTanks
            hasRemovedCoffeeGround
            hasRinsedMachine
            isMachineWorking
            isFinishForced
            isNeeded
            locations {
                productId
                microstoreLocationId
                initialTrayLevel
                targetTrayLevel
            }
            needsCleaningMachine
            state
            stateHistory {
                createdAt
                state
            }
            type
            updatedAt
        }
        ... on InventoryInstruction {
            createdAt
            isFinishForced
            isNeeded
            state
            stateHistory {
                createdAt
                state
            }
            type
            updatedAt
        }
        ... on MicrowaveInstruction {
            createdAt
            hasCleanedMicrowaves
            isFinishForced
            isNeeded
            state
            stateHistory {
                createdAt
                state
            }
            type
            updatedAt
        }
        ... on WaterFountainInstruction {
            createdAt
            hasCleanedWaterFountain
            isFinishForced
            isNeeded
            state
            stateHistory {
                createdAt
                state
            }
            type
            updatedAt
        }
        ... on MoveProductsInstruction {
            createdAt
            isFinishForced
            isNeeded
            state
            stateHistory {
                createdAt
                state
            }
            type
            updatedAt
        }
        ... on PhotosInstruction {
            _id
            createdAt
            isFinishForced
            isNeeded
            photos {
                isMandatory
                type
                urls
            }
            controlPhotos {
                ...ControlPhotoFragment
            }
            state
            stateHistory {
                createdAt
                state
            }
            type
            updatedAt
        }
        ... on RemoveProductsInstruction {
            createdAt
            isFinishForced
            isNeeded
            removedProducts {
                microstoreLocationIds
                productId
                quantityDetails {
                    expiryDate
                    quantity
                }
            }
            state
            stateHistory {
                createdAt
                state
            }
            type
            updatedAt
        }
        ... on StoreProductsInstruction {
            createdAt
            isFinishForced
            isNeeded
            state
            stateHistory {
                createdAt
                state
            }
            type
            updatedAt
        }
        ... on ManualReassortInstruction {
            createdAt
            isFinishForced
            isNeeded
            entries {
                _id
                productId
                quantity
                truckColumnId
                columnId
                createdAt
            }
            state
            stateHistory {
                createdAt
                state
            }
            type
            updatedAt
        }
        ... on TheftNoticeInstruction {
            createdAt
            isFinishForced
            isNeeded
            needMoreNotices
            state
            stateHistory {
                createdAt
                state
            }
            type
            updatedAt
        }
    }
    ${CONTROL_PHOTO_FRAGMENT}
`;

export const SETUP_INSTRUCTION_CONTROL_PHOTOS_FRAGMENT = gql`
    fragment SetupInstructionControlPhotosFragment on SetupInstruction {
        ... on PhotosInstruction {
            _id
            type
            photos {
                isMandatory
                type
                urls
            }
            controlPhotos {
                ...ControlPhotoFragment
            }
        }
    }
    ${CONTROL_PHOTO_FRAGMENT}
`;

export const CHECK_TEMPERATURE_INSTRUCTION_FRAGMENT = gql`
    fragment CheckTemperatureInstructionFragment on CheckTemperatureInstruction {
        createdAt
        isFinishForced
        isNeeded
        noTemperatureComment
        state
        stateHistory {
            createdAt
            state
        }
        temperature
        type
        updatedAt
    }
`;

export const CHECK_BOX_TEMPERATURE_INSTRUCTION_FRAGMENT = gql`
    fragment CheckBoxTemperatureInstructionFragment on CheckBoxTemperatureInstruction {
        createdAt
        isFinishForced
        isNeeded
        noTemperatureComment
        state
        stateHistory {
            createdAt
            state
        }
        temperature
        thermometerNumber
        type
        updatedAt
    }
`;

export const HOT_DRINKS_INSTRUCTION_FRAGMENT = gql`
    fragment HotDrinksInstructionFragment on HotDrinksInstruction {
        createdAt
        hasCleanedCollectingTray
        hasCleanedMachine
        hasReplenishedConsumables
        hasReplenishedTanks
        hasRemovedCoffeeGround
        hasRinsedMachine
        isMachineWorking
        isFinishForced
        isNeeded
        locations {
            productId
            microstoreLocationId
            initialTrayLevel
            targetTrayLevel
        }
        needsCleaningMachine
        state
        stateHistory {
            createdAt
            state
        }
        type
        updatedAt
    }
`;

export const INVENTORY_INSTRUCTION_FRAGMENT = gql`
    fragment InventoryInstructionFragment on InventoryInstruction {
        createdAt
        isFinishForced
        isNeeded
        state
        stateHistory {
            createdAt
            state
        }
        type
        updatedAt
    }
`;

export const MICROWAVE_INSTRUCTION_FRAGMENT = gql`
    fragment MicrowaveInstructionFragment on MicrowaveInstruction {
        createdAt
        hasCleanedMicrowaves
        isFinishForced
        isNeeded
        state
        stateHistory {
            createdAt
            state
        }
        type
        updatedAt
    }
`;

export const MOVE_PRODUCTS_INSTRUCTION_FRAGMENT = gql`
    fragment MoveProductsInstructionFragment on MoveProductsInstruction {
        createdAt
        isFinishForced
        isNeeded
        state
        stateHistory {
            createdAt
            state
        }
        type
        updatedAt
    }
`;

export const PHOTOS_INSTRUCTION_FRAGMENT = gql`
    fragment PhotosInstructionFragment on PhotosInstruction {
        _id
        createdAt
        isFinishForced
        isNeeded
        photos {
            isMandatory
            type
            urls
        }
        controlPhotos {
            ...ControlPhotoFragment
        }
        state
        stateHistory {
            createdAt
            state
        }
        type
        updatedAt
    }
    ${CONTROL_PHOTO_FRAGMENT}
`;

export const REMOVE_PRODUCTS_INSTRUCTION_FRAGMENT = gql`
    fragment RemoveProductsInstructionFragment on RemoveProductsInstruction {
        createdAt
        isFinishForced
        isNeeded
        removedProducts {
            microstoreLocationIds
            productId
            quantityDetails {
                expiryDate
                quantity
            }
        }
        state
        stateHistory {
            createdAt
            state
        }
        type
        updatedAt
    }
`;

export const STORE_PRODUCTS_INSTRUCTION_FRAGMENT = gql`
    fragment StoreProductsInstructionFragment on StoreProductsInstruction {
        createdAt
        isFinishForced
        isNeeded
        state
        stateHistory {
            createdAt
            state
        }
        type
        updatedAt
    }
`;

export const MANUAL_REASSORT_INSTRUCTION_FRAGMENT = gql`
    fragment ManualReassortInstructionFragment on ManualReassortInstruction {
        createdAt
        isFinishForced
        isNeeded
        entries {
            _id
            productId
            quantity
            truckColumnId
            columnId
            createdAt
        }
        state
        stateHistory {
            createdAt
            state
        }
        type
        updatedAt
    }
`;

export const THEFT_NOTICE_INSTRUCTION_FRAGMENT = gql`
    fragment TheftNoticeInstructionFragment on TheftNoticeInstruction {
        createdAt
        isFinishForced
        isNeeded
        needMoreNotices
        state
        stateHistory {
            createdAt
            state
        }
        type
        updatedAt
    }
`;
